<div id="fullScreen" fxLayout="column">
  <h2 id="title" class="page-header" fxFill>Mantenimiento de Remito de Vehículo</h2>
  <form fxLayout="column" style="margin: 2.5rem" [formGroup]="createVehicleRemitoForm" #formDirective="ngForm" autocomplete="off">
    <div id="vinSeleccionado" fxLayout="column">
      <h5 id="vinSeleccionadoHeader" class="section-header">Vin Seleccionado</h5>
      <mat-divider id="vinSeleccionadoDivider" class="mat-divider-header"></mat-divider>
      <div id="vinSeleccionadoForm" fxLayout="column" fxLayoutGap="1rem" style="margin: 2rem">
        <div id="vinSeleccionadoRow1" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap.gt-sm="1rem" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="23%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>VIN Letras</mat-label>
            <input matInput #vinLetrasInput [formControl]="vinLetrasControl"
                   placeholder="Vin Letras" (input)="vinSearch()" maxlength="11">
            <mat-hint align="end">{{vinLetrasInput.value.length || 0}}/11</mat-hint>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="23%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>VIN Numeros</mat-label>
            <input matInput #vinNumerosInput [formControl]="vinNumerosControl"
                   placeholder="Vin Numeros" (input)="vinSearch()" minlength="6" maxlength="6">
            <mat-hint align="end">{{vinNumerosInput.value.length || 0}}/6</mat-hint>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="23%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Año Modelo</mat-label>
            <input matInput #anoModeloInput [formControl]="anoModeloControl"
                   placeholder="Año Modelo" minlength="4" maxlength="4">
            <mat-hint align="end">{{anoModeloInput.value.length || 0}}/4</mat-hint>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="23%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Modelo</mat-label>
            <input matInput #modeloInput [formControl]="modeloControl"
                   placeholder="Modelo" maxlength="30">
            <mat-hint align="end">{{modeloInput.value.length || 0}}/30</mat-hint>
          </mat-form-field>
        </div>
        <div id="vinSeleccionadoRow2" fxLayout="row wrap" fxLayoutAlign="start center"  fxLayoutGap.gt-sm="1rem" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="23%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Vehículo</mat-label>
            <input matInput #vehiculoInput [formControl]="vehiculoControl"
                   placeholder="Vehículo" maxlength="40">
            <mat-hint align="end">{{vehiculoInput.value.length || 0}}/40</mat-hint>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="23%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Color Externo</mat-label>
            <input matInput #colorExternoInput [formControl]="colorExternoControl"
                   placeholder="Color Externo" maxlength="30">
            <mat-hint align="end">{{colorExternoInput.value.length || 0}}/30</mat-hint>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="23%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Color Interno</mat-label>
            <input matInput #colorInternoInput [formControl]="colorInternoControl"
                   placeholder="Color Interno" maxlength="30">
            <mat-hint align="end">{{colorInternoInput.value.length || 0}}/30</mat-hint>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="23%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Motor</mat-label>
            <input matInput #motorInput [formControl]="motorControl"
                   placeholder="Motor" maxlength="20">
            <mat-hint align="end">{{motorInput.value.length || 0}}/20</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div id="datosDelRemito" fxLayout="column">
      <h5 id="datosDelRemitoHeader" class="section-header">Datos del Remito</h5>
      <mat-divider id="datosDelRemitoDivider"  class="mat-divider-header"></mat-divider>
      <div id="datosDelRemitoForm" fxLayout="column" fxLayoutGap="1rem" style="margin: 2rem">
        <div id="datosDelRemitoRow1" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap.gt-sm="1rem" fxLayoutGap.lt-md="0">
            <mat-form-field fxFlex.gt-sm="16%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline" disabled="true">
              <mat-label>Pto Emision</mat-label>
              <mat-select [disabled]="true" [formControl]="ptoEmisionControl" panelClass="mat-select-dropdown">
                <mat-option *ngFor="let ptoEmision of filteredPtoEmision"
                            [value]="ptoEmision.id" ngDefaultControl >
                  {{ ptoEmision.id }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ptoEmisionControl.hasError('required')">Seleccione Pto de emision</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex.gt-sm="16%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
              <mat-label>Nro Remito</mat-label>
              <input matInput placeholder="NRO Remito" [formControl]="nroRemitoControl">
            </mat-form-field>
            <mat-form-field fxFlex.gt-sm="18%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
              <mat-label>Clase <span class="required-indicator">*</span></mat-label>
              <mat-select [(value)]="claseSelected" [disabled]="isView">
                <mat-option *ngFor="let clase of clase" [value]="clase.id">
                  {{clase.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex.gt-sm="16%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
              <mat-label>Fec Gen <span class="required-indicator">*</span></mat-label>
              <input matInput [matDatepicker]="fecGen" [formControl]="fecGenControl" readonly>
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="fecGen" disabled></mat-datepicker-toggle>
              <mat-datepicker #fecGen></mat-datepicker>
            </mat-form-field>
          <mat-form-field fxFlex.gt-sm="25%" fxFlex.sm="39%" fxFlex.lt-sm="100%"  appearance="standard">
            <mat-label>Origen</mat-label>
            <input type="text" matInput [formControl]="origenControl" [matAutocomplete]="autoOrigen">
            <mat-autocomplete #autoOrigen="matAutocomplete">
              <mat-option *ngFor="let origen of filteredOrigen | async"
                          [value]="origen.id + ' - ' + origen.desc + ' - ' + origen.dlCiudad">
                {{origen.id}} - {{origen.desc}} - {{origen.dlCiudad}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="origenControl.hasError('required')">Seleccione un Origen</mat-error>
            <mat-error *ngIf="origenControl.hasError('in-valid-list')">Seleccione un Origen Válido</mat-error>
          </mat-form-field>

        </div>
        <div id="datosDelRemitoRow2" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap.gt-sm="1rem" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="standard">
            <mat-label>Transporte</mat-label>
            <input type="text" matInput [formControl]="transporteControl" [matAutocomplete]="autoTransporte">
            <mat-autocomplete #autoTransporte="matAutocomplete">
                        <mat-option *ngFor="let transporte of filteredTransporte | async"
                                    [value]="transporte.id + ' - ' + transporte.desc"
                                    (click)="transporteSelection(transporte.id)">
                          {{transporte.id}} - {{transporte.desc}}
                        </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="transporteControl.hasError('required')">Seleccione un Transportista</mat-error>
            <mat-error *ngIf="transporteControl.hasError('in-valid-list')">Seleccione un Transportista Válido</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Domicilio</mat-label>
            <input matInput maxlength="4" placeholder="Domicilio" [formControl]="transDomicilioControl">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Localidad</mat-label>
            <input matInput maxlength="4" placeholder="Localidad" [formControl]="transLocalidadControl">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="10%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Postal Code</mat-label>
            <input matInput maxlength="4" placeholder="Postal Code" [formControl]="transPostalCodeControl">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="10%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>CUIT Nro</mat-label>
            <input matInput maxlength="4" placeholder="CUIT Nro" [formControl]="transCuitNroControl">
          </mat-form-field>
        </div>
        <div id="datosDelRemitoRow3" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap.gt-sm="1rem" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="39%" fxFlex.lt-sm="100%"  appearance="standard">
            <mat-label>Destinatario</mat-label>
            <input type="text" matInput [formControl]="destinatarioControl" [matAutocomplete]="autoDestinatario">
            <mat-autocomplete #autoDestinatario="matAutocomplete">
                        <mat-option *ngFor="let destinatario of filteredDestinatario | async"
                                    [value]="destinatario.id + ' - ' + destinatario.desc + ' - ' + destinatario.dlCiudad"
                                    (click)="destinatarioSelection(destinatario.id)">
                          {{destinatario.id}} - {{destinatario.desc}} - {{destinatario.dlCiudad}}
                        </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="destinatarioControl.hasError('required')">Seleccione un Destinatario</mat-error>
            <mat-error *ngIf="destinatarioControl.hasError('in-valid-list')">Seleccione un Destinatario Válido</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="39%" fxFlex.lt-sm="100%"  appearance="outline">
            <mat-label>Domicilio</mat-label>
            <input matInput maxlength="4" placeholder="Domicilio" [formControl]="destDomicilioControl">
          </mat-form-field>

          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="39%" fxFlex.lt-sm="100%"  appearance="outline">
            <mat-label>Localidad</mat-label>
            <input matInput maxlength="4" placeholder="Localidad" [formControl]="destLocalidadControl">
          </mat-form-field>

          <mat-form-field fxFlex.gt-sm="10%" fxFlex.sm="39%" fxFlex.lt-sm="100%"  appearance="outline">
            <mat-label>Provincia</mat-label>
            <input matInput maxlength="4" placeholder="Provincia" [formControl]="provinciaControl">
          </mat-form-field>

          <mat-form-field fxFlex.gt-sm="10%" fxFlex.sm="39%" fxFlex.lt-sm="100%"  appearance="outline">
            <mat-label>Postal Code</mat-label>
            <input matInput maxlength="4" placeholder="Postal Code" [formControl]="destPostalCodeControl">
          </mat-form-field>
        </div>
        <div id="datosDelRemitoRow4" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap.gt-sm="1rem" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="15%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Ingresos Brutos</mat-label>
            <input matInput maxlength="4" placeholder="Ingresos Brutos" [formControl]="ingresosBrutosControl">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="15%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Condicion IVA</mat-label>
            <input matInput maxlength="4" placeholder="Condicion IVA" [formControl]="condicionIvaControl">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="15%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>CUIT Nro</mat-label>
            <input matInput maxlength="4" placeholder="CUIT Nro" [formControl]="destCuitNroControl">
          </mat-form-field>
        </div>
        <div *ngIf="!isCancelled" id="datosDelRemitoRow5" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap.gt-sm="1rem" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="48%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Nota</mat-label>
            <input matInput #observacionInput maxlength="100" [formControl]="observacionControl"
                   placeholder="Nota">
            <mat-hint align="end">{{observacionInput.value.length || 0}}/100</mat-hint>
          </mat-form-field>
        </div>
        <div *ngIf="isCancelled" id="datosDelRemitoRow7" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap.gt-sm="1rem" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="48%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Cancelar Observacion</mat-label>
            <input matInput #cancelarObservacionInput maxlength="100" [formControl]="cancelarObservacionControl"
                   placeholder="Cancelar Observacion">
            <mat-hint align="end">{{cancelarObservacionInput.value.length || 0}}/100</mat-hint>
          </mat-form-field>
        </div>
        <div id="datosDelRemitoRow6" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap.gt-sm="1rem" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="48%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="standard">
            <mat-label>Impresoras</mat-label>
            <input type="text" matInput [formControl]="impresorasControl" [matAutocomplete]="autoImpresoras">
            <mat-autocomplete #autoImpresoras="matAutocomplete">
              <mat-option *ngFor="let impresoras of filteredImpresoras | async"
                          [value]="impresoras.id + ' - ' + impresoras.desc">
                {{impresoras.id}} - {{impresoras.desc}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="impresorasControl.hasError('required')">Seleccione un Impresoras</mat-error>
            <mat-error *ngIf="impresorasControl.hasError('in-valid-list')">Seleccione un Impresoras Válido</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div id="footerButtons" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1.5rem" style="text-align:center;">
      <button mat-raised-button fxFlex="0 1 10rem" color="primary" style="width:150px; margin:10px;" type="button"
              [disabled]="isView || isSaving" (click)="save()">
        <mat-spinner *ngIf="isSaving" class="loading-spinner-small" diameter="30"></mat-spinner>
        <span *ngIf="!isSaving">Generar Remito</span>
      </button>
      <button mat-raised-button fxFlex="0 1 10rem" color="accent" style="width:150px; margin:10px;" type="button"
              [disabled]="isView" (click)="clearForm()">
        Limpiar
      </button>
    </div>
  </form>
</div>
